import { z } from 'zod';

export const updateSubscriptionByAdminSchema = z.object({
  user_id: z.uuid(),
  end_at: z.string().datetime(),
});

export type UpdateSubscriptionByAdminPayload = z.infer<typeof updateSubscriptionByAdminSchema>;
